// extracted by mini-css-extract-plugin
module.exports = {"container":"_7c90350","content":"_87f1d27","actionButtons":"_f930636","footNote":"_d932a40","desktopVisible":"_8448266","mobileVisible":"_277787c"};